export default "__VITE_ASSET__4USCt7jQ__"